import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import ThemeProvider from "./theme/ThemeProvider";
import { Switch, Route } from "react-router-dom";
import MaxiOperation from "./pages/MaxiOperation/index";
import MaxiOperationMA from "./pages/MaxiOperation/ma_list";
import ReportList from "./pages/report/report_list";
import Report from "./pages/report/report";
import dynamic_report from "./pages/report/dynamic_report";
import PlanningJob from "./pages/MaxiOperation/planning_jobs";
import Setting from "./pages/MaxiOperation/setting";
import RecordProblem from "./pages/MaxiOperation/record_problem";
import FullDetailJob from "./pages/MaxiOperation/full_detail_job";
import Addjob from "./pages/MaxiOperation/addjob";
import PhotoReport from "./pages/MaxiOperation/photo_report";
import Addmaterial from "./pages/MaxiOperation/addmaterial";
import MaterialStock from "./pages/MaxiOperation/MaterialStock";
import PhotoReportID from "./pages/MaxiOperation/photo_report/id";
import Dashboard from "./pages/MaxiOperation/dashboard";
import TeamManagenent from "./pages/MaxiOperation/team_management";
import AssetList from "./pages/MaxiOperation/asset_list";
import AllJobAsset from "./pages/MaxiOperation/all_jobs_asset";
import Login from "./pages/MaxiOperation/login";
import reset_password from "./pages/MaxiOperation/reset_password";
import ForGotPassWord from "./pages/MaxiOperation/ForGotPassWord";
import ChangePassWord from "./pages/MaxiOperation/ChangePassWord";
import AuthenTwoFA from "./pages/MaxiOperation/AuthenTwoFA";
// import NotificationList from "./pages/MaxiOperation/notifications_list";
import InformList from "./pages/MaxiOperation/inform_problem_list";
import InformDetail from "./pages/MaxiOperation/inform_problem_detail";
import Editjob from "./pages/MaxiOperation/editjob";
import AddJob_Infra from "./pages/MaxiOperation/addjob_infra";
// import Monitor from "./pages/MaxiOperation/monitor";
import Mahistory from "./pages/MaxiOperation/ma_history";
import Configuration from "./ui/setting/configuration_translate";
import SelectModules from "./pages/MaxiOperation/SelectModules";
import BusStatusChecking from "./pages/MaxiOperation/bus_status_checking/BusStatusChecking";
import BusDetail from "./pages/MaxiOperation/bus_detail/BusDetail";
// import JobDetail from "./pages/MaxiOperation/job_detail/JobDetail";
import JobDetail from "./pages/MaxiOperation/job_detail/JobDetail_new";
import JobDetailViewOnly from "./pages/MaxiOperation/job_detail/JobDetail_new_view_only";

import JobDetail_new from "./pages/MaxiOperation/job_detail/JobDetail_new";

import LeaveManagement from "./pages/MaxiOperation/leave_management_list";
import LeaveManagementDetail from "./pages/MaxiOperation/leave_management_detail";
// import TestCode from "./ui/testtable";
import Notfound from "./pages/Notfound";

// import DashboardTest from "./pages/MaxiOperation/Dashborad/dashboard_digital";
// import DashboardMobile from "./pages/MaxiOperation/Dashborad/dashborad_moile";
// import DashboardStatic from "./pages/MaxiOperation/Dashborad/dashboard_static";
// import DashboardBus from "./pages/MaxiOperation/Dashborad/dashboard_bus";
// import DashboardAirport from "./pages/MaxiOperation/Dashborad/dashboard_airport";

import DashboardMain from "./pages/MaxiOperation/Dashborad/index";

/* for mockup */
import BoldMAlist from "./pages/uih/ma_list";
// import BlodNewMA from "./pages/uih/ma_list/ma_list";
import JobHistory from "./pages/uih/JobHistory";
import BoldAddJob from "./pages/uih/Addjob";
import BoldEditJob from "./pages/uih/wf_controllers/editjob/EditjobController";
import BoldCreateJob from "./pages/uih/wf_controllers/editjob/CreateJobNew";
import BoldFullDetailJob from "./pages/uih/wf_controllers/controller";
import BoldCopyJob from "./pages/uih/copyjob/Copyjob";
import RepairingPoint from "./components/uih/repairing_points";

// bbtecDashboard
import BBtecDashboard from "./pages/MaxiOperation/bbtecDashboard";

import MonitorDashboard from "./pages/uih/dashboardMonitor/DashboardMonitor"; // Not include login
// context
import { AuthContext } from "./contexts";
import ServiceApi from "./services/ServiceApi";
import { notification } from "antd";
// import firebase from "firebase";

import UserProfile from "./pages/MaxiOperation/UserProfile";
// import QrReader from "./qr_reader/qr_reader"


import SelectAssign from "./pages/MaxiOperation/SelectAssign";

import Joblist from "./pages/uih/newJob/newJob";

const NotFoundPage = () => <Notfound></Notfound>;
const CompanyId = Number(Cookies.get("companyid"));
const OperatorId = Number(Cookies.get("operator_id"));
const ProjectId = Number(Cookies.get("project_id"));
const ProjectData = JSON.parse(localStorage.getItem("projectData"))?.filter(
  (data) => {
    return (
      data.operator_id === OperatorId &&
      data.company_id === CompanyId &&
      data.project_id === ProjectId
    );
  }
);

const App = () => {
  return (
    <ThemeProvider>
      <AuthContext>
        <Switch>
        <Route exact path="/SelectAssignOperation" component={SelectAssign} />
          <Route exact path="/TestCode" component={JobDetail_new} />
          <Route exact path="/newjob" component={Joblist} />
          <Route exact path="/Code" component={RepairingPoint} />
          <Route exact path="/" component={MaxiOperation} />
          <Route exact path="/login" component={Login} />
          {/* <Route exact path="/qr_reader" component={QrReader} /> */}

          <Route
            exact
            path="/SelectModules"
            children={<SelectModules></SelectModules>}
          />
          <Route exact path="/reset_password" component={reset_password} />
          <Route exact path="/forget_password" component={ForGotPassWord} />
          <Route exact path="/change_password" component={ChangePassWord} />
          <Route exact path="/authentication_2factor" component={AuthenTwoFA} />

          {+CompanyId === 3 && (
            <Route
              exact
              path="/ma_list/:company_id/:operator_id/:project_id"
              children={
                <BoldMAlist
                // CompanyId={CompanyId}
                // OperatorId={OperatorId}
                // ProjectId={ProjectId}
                // ProjectData={ProjectData}
                />
              }
            />
          )}
                    {+CompanyId === 3 && (
            <Route
              exact
              path="/ma_list/:company_id/:operator_id"
              children={
                <BoldMAlist
                // CompanyId={CompanyId}
                // OperatorId={OperatorId}
                // ProjectId={ProjectId}
                // ProjectData={ProjectData}
                />
              }
            />
          )}
          {+CompanyId === 3 && (
            <Route
              exact
              path="/ma_list"
              children={
                <BoldMAlist
                // CompanyId={CompanyId}
                // OperatorId={OperatorId}
                // ProjectId={ProjectId}
                // ProjectData={ProjectData}
                />
              }
            />
          )}

          <Route exact path="/job_history" component={JobHistory} />
          <Route exact path="/report_list" component={ReportList} />
          <Route
            exact
            path="/report"
            component={CompanyId === 1 ? dynamic_report : Report}
          /> 
          {/* <Route exact path="/ma_list" component={MaxiOperationMA} /> */}
          {/* <Route exact path="/ma_list" component={BoldMAlist} /> */}
          
          <Route exact path="/Configuration" component={Configuration} />
          {/* <Route exact path="/notifications" component={NotificationList} /> */}
          <Route exact path="/planning_jobs" component={PlanningJob} />
          <Route exact path="/setting" component={Setting} />
          <Route exact path="/record_problem" component={RecordProblem} />
          {+CompanyId === 3 && (
            <Route
              path="/copyjob/:company_id/:operator_id/:project_id/:job_id"
              children={<BoldCopyJob></BoldCopyJob>}
            ></Route>
          )}
          {+CompanyId === 3 && (
            <Route
              exact
              path="/full_detail_job/:company_id/:operator_id/:project_id/:job_id"
              children={<BoldFullDetailJob></BoldFullDetailJob>}
            />
          )}

          <Route exact path="/full_detail_job" component={FullDetailJob} />

          {+CompanyId === 3 && (
            <Route
              exact
              path="/Addjob"
              children={
                <BoldAddJob
                  CompanyId={CompanyId}
                  OperatorId={OperatorId}
                  ProjectId={ProjectId}
                  ProjectData={ProjectData}
                ></BoldAddJob>
              }
            />
          )}
          <Route exact path="/Addjob" component={Addjob} />
          <Route exact path="/photo_report" component={PhotoReport} />
          <Route exact path="/Addmaterial" component={Addmaterial} />
          <Route exact path="/MaterialStock" component={MaterialStock} />
          {/* <Route exact path="/Monitor" component={Monitor} /> */}
          <Route exact path="/photo_report/:id" component={PhotoReportID} />
          <Route exact path="/bus_detail" component={BusDetail} />
          <Route exact path="/job_detail" component={JobDetail} />
          <Route
            exact
            path="/job_detail_view_only"
            component={JobDetailViewOnly}
          />

          <Route
            exact
            path="/bus_status_checking"
            component={BusStatusChecking}
          />

          {+CompanyId === 1 &&
            (OperatorId === 1 ||
              OperatorId === 2 ||
              OperatorId === 3 ||
              OperatorId === 4) ? (
            <Route exact path="/dashboard" component={DashboardMain} />
          ) : null}

          <Route
            exactๅ
            path="/dashboardMobile/:operator_id"
            component={DashboardMain}
          />

          {/* <Route exact path="/DashboardStatic" component={DashboardStatic} /> */}

          {+CompanyId === 3 && (
            <Route
              exact
              path="/dashboard"
              children={<BBtecDashboard></BBtecDashboard>}
            />
          )}
          {+CompanyId === 3 && (
            <Route
              exact
              path="/dashboard/:view_mode"
              children={<BBtecDashboard></BBtecDashboard>}
            />
          )}
          <Route exact path="/team_management" component={TeamManagenent} />
          <Route exact path="/asset_list" component={AssetList} />
          <Route exact path="/all_jobs_asset" component={AllJobAsset} />
          <Route exact path="/inform_problem_list" component={InformList} />
          <Route exact path="/inform_problem_detail" component={InformDetail} />
          <Route exact path="/ma_history" component={Mahistory} />
          {+CompanyId === 3 && (
            <>
            <Route
              exact
              path="/Editjob/:company_id/:operator_id/:project_id/:job_id"
              children={<BoldEditJob></BoldEditJob>}
            />
            <Route
            exact
            path="/CreateJob/:company_id/:operator_id/:project_id/:job_id"
            children={<BoldCreateJob></BoldCreateJob>}
          />
          </>
          )}
      
          <Route exact path="/Editjob" component={Editjob} />
          <Route exact path="/Addjob_Infra" component={AddJob_Infra} />
          <Route exact path="/publicwebview" component={Dashboard} />
          <Route exact path="/leave_management" component={LeaveManagement} />
          <Route
            exact
            path="/leave_management_detail"
            component={LeaveManagementDetail}
          />
          <Route exact path="/user-profile" component={UserProfile} />

   
          <Route
            exact
            path="/dashboard/monitor/:company"
            children={<MonitorDashboard></MonitorDashboard>}
          />
          <Route exact path="" component={MaxiOperation} />
          <Route component={NotFoundPage} />
        </Switch>
      </AuthContext>
    </ThemeProvider>
  );
  // }
};

export default App;
